<template>
    <div >
        <slot name="title">
        </slot>
    </div>
</template>
<script>
export default{

}
</script>